import React from 'react';
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { useThemeColors } from '../hooks/useThemeColors';

/**
 * Breadcrumb navigation component
 * @param {Object[]} items - Array of breadcrumb items with label and optional path
 * @param {string} items[].label - Display text for the breadcrumb
 * @param {string} [items[].path] - Navigation path (last item should not have a path)
 */
export default function Breadcrumbs({ items }) {
  const navigate = useNavigate();
  const { isDark, accentBlue } = useThemeColors();

  if (!items || items.length === 0) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <MuiBreadcrumbs
        separator={<NavigateNextIcon fontSize="small" sx={{ color: isDark ? '#888' : '#666' }} />}
        sx={{
          '& .MuiBreadcrumbs-ol': {
            flexWrap: 'nowrap'
          }
        }}
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          if (isLast || !item.path) {
            return (
              <Typography
                key={item.label}
                color="text.primary"
                variant="body2"
                sx={{
                  fontWeight: 500,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: { xs: 150, sm: 300 }
                }}
              >
                {item.label}
              </Typography>
            );
          }

          return (
            <Link
              key={item.path}
              component="button"
              variant="body2"
              onClick={() => navigate(item.path)}
              sx={{
                color: accentBlue,
                textDecoration: 'none',
                fontWeight: 500,
                '&:hover': {
                  textDecoration: 'underline',
                  cursor: 'pointer'
                },
              }}
            >
              {item.label}
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
}
